import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  Input,
  shorthands,
  makeStyles,
  Label,
  Text,
  Textarea,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    // Stack the label above the field with a gap
    display: 'grid',
    gridTemplateRows: 'repeat(1fr)',
    justifyItems: 'start',
    ...shorthands.gap('2px'),
  },
  textRoot: {
    minWidth: '100%',
    '& input[type="text"]:hover': {
      // borderStyle: 'none', // remove border style, in v9 we have no border
    },
    '& input[type="text"]:focus': {
      // borderStyle: 'none',
    },
  },
});

const PrefixSuffixRenderer = (props) => {
  const { text, customRenderer } = props;

  if (customRenderer) {
    return customRenderer(props);
  }

  return (
    <Text>{text}</Text>
  );
};

PrefixSuffixRenderer.propTypes = {
  text: PropTypes.string,
  customRenderer: PropTypes.func,
};

PrefixSuffixRenderer.defaultProps = {
  text: undefined,
  customRenderer: undefined,
};

const onRenderLabelDefault = (props) => {
  const { label, required } = props;
  return (
    <Label weight="semibold" required={required}>{label}</Label>
  );
};

const TextFieldShimInternal = (props) => {
  const {
    label, multiline, resize, className, required, onChange, onRenderLabel, prefix, suffix, onRenderSuffix, onRenderPrefix, ...rest
  } = props;

  const styles = useStyles();

  const contentBefore = (prefix || onRenderPrefix) && <PrefixSuffixRenderer text={prefix} customRenderer={onRenderPrefix} />;

  const contentAfter = (suffix || onRenderSuffix) && <PrefixSuffixRenderer text={suffix} customRenderer={onRenderSuffix} />;

  const onChangeWrapper = (event, data) => {
    if (onChange) {
      onChange(event, data.value);
    }
  };
  return (
    <div className={classNames(styles.root, className)}>
      {label && !onRenderLabel && onRenderLabelDefault(props)}
      {onRenderLabel && onRenderLabel(props, onRenderLabelDefault)}
      { multiline ? (
        <Textarea
          className={styles.textRoot}
          {...rest}
          resize={resize}
          onChange={onChangeWrapper}
        />
      ) : (
        <Input
          className={styles.textRoot}
          contentAfter={contentAfter}
          contentBefore={contentBefore}
          onChange={onChangeWrapper}
          {...rest}
        />
      )}
    </div>
  );
};

TextFieldShimInternal.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  onRenderLabel: PropTypes.func,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  onRenderSuffix: PropTypes.func,
  onRenderPrefix: PropTypes.func,
  onChange: PropTypes.func,
  resize: PropTypes.oneOf(['both', 'horizontal', 'vertical', 'none']),
  multiline: PropTypes.bool,
  className: PropTypes.string,
};

TextFieldShimInternal.defaultProps = {
  label: undefined,
  required: false,
  onRenderLabel: undefined,
  prefix: undefined,
  suffix: undefined,
  onRenderSuffix: undefined,
  onRenderPrefix: undefined,
  onChange: undefined,
  resize: 'both', // to maintain similarity with v8
  multiline: false,
  className: undefined,
};

export const TextFieldShim = TextFieldShimInternal;
